import React from 'react';
import { engagementDisplayName } from '../../utils/engagementName';
import { coverageList, coverageListItem } from '../workflow/constants';

/**
 * An addendum's per-engagement rating revisions (risk_changes) — one line
 * each: "Company — Service: Low → High", the reason underneath. Shared by the
 * QCAD detail page, the addenda lists and the Client Hub timeline.
 *
 * `engagementName` is the label filed with the revision ("Company — Service
 * #n · description", engagementTag); the API adds the engagement's live
 * `serviceDescription`, appended only when the filed label does not carry it.
 */
const changeLabel = (c) => {
  const name = c.engagementName || `Engagement #${c.engagementId}`;
  const head = c.serviceDescription;
  return head && name.includes(head) ? name : engagementDisplayName(name, c.serviceDescription);
};

const RiskChangesList = ({ changes = [] }) => (
  <ul className={coverageList}>
    {changes.map((c) => (
      <li key={c.engagementId} className={coverageListItem}>
        <span className="text-slate-800">{changeLabel(c)}: </span>
        <span className="font-medium text-amber-700">{c.from || '—'} → {c.to}</span>
        {c.reason ? <div className="text-xs text-slate-600 whitespace-pre-line break-words">{c.reason}</div> : null}
      </li>
    ))}
  </ul>
);

export default RiskChangesList;
